import { ArrowRight, BookOpen, CalendarDays, Quote, Download, ShieldCheck, RotateCcw } from "lucide-react";
import { Reveal } from "./Reveal";
import { CHECKOUT_URL, PRICE_ORIGINAL, PRICE_DISCOUNTED } from "@/lib/constants";

const INCLUDES = [
  { icon: BookOpen, text: "E-book completo ESTÓICO em PDF e ePub (8 capítulos + exercícios)" },
  { icon: CalendarDays, text: "Bônus: Desafio 21 Dias de Prática Estoica" },
  { icon: Quote, text: "Bônus: 30 cartões de reflexão diária para imprimir" },
  { icon: Download, text: "Download imediato após a confirmação do pagamento" },
];

export const Pricing = () => (
  <section id="oferta" data-testid="pricing-offer-section" className="py-20 md:py-28 relative overflow-hidden">
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-[#d4af37]/[0.06] blur-[130px] rounded-full pointer-events-none" />
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <Reveal className="text-center">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">Oferta de lançamento</p>
        <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#f4f1ea]">
          Tudo isso por menos que <span className="text-gold-gradient italic">um almoço</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 rounded-3xl border border-[#d4af37]/30 bg-gradient-to-b from-[#1f1a08]/70 to-[#14141a] p-8 md:p-12 gold-glow">
          <div className="flex flex-col items-center text-center">
            <span className="bg-[#d4af37]/15 border border-[#d4af37]/40 text-[#f5d77f] font-mono text-[11px] uppercase tracking-[0.25em] px-4 py-1.5 rounded-full">
              37% de desconto · por tempo limitado
            </span>
            <div className="mt-7 flex items-baseline gap-4">
              <span data-testid="pricing-original" className="text-zinc-500 line-through text-xl sm:text-2xl">{PRICE_ORIGINAL}</span>
              <span data-testid="pricing-discounted" className="font-serif text-6xl sm:text-7xl font-bold text-gold-gradient">{PRICE_DISCOUNTED}</span>
            </div>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Pagamento único · acesso vitalício</p>
          </div>

          <ul className="mt-10 space-y-4 max-w-lg mx-auto">
            {INCLUDES.map((item) => (
              <li key={item.text} className="flex items-start gap-4">
                <item.icon className="w-5 h-5 text-[#d4af37] shrink-0 mt-0.5" strokeWidth={1.5} />
                <span className="text-sm sm:text-base text-zinc-300 leading-relaxed">{item.text}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col items-center">
            <a
              data-testid="pricing-buy-button"
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-gold-gradient text-[#08080a] font-extrabold text-base sm:text-lg px-10 py-5 rounded-full transition-transform duration-300 hover:scale-[1.04]"
            >
              Comprar agora por {PRICE_DISCOUNTED}
              <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-zinc-500">
              <span className="flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-[#d4af37]" /> Compra 100% segura</span>
              <span className="flex items-center gap-1.5"><Download className="w-4 h-4 text-[#d4af37]" /> Entrega imediata</span>
              <span className="flex items-center gap-1.5"><RotateCcw className="w-4 h-4 text-[#d4af37]" /> Garantia de 7 dias</span>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
